<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="标题">
                <a-input v-model="queryParam.title" placeholder="请输入标题" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="客户端">
                <a-select placeholder="请选择" v-model="queryParam.clientType" style="width: 100%" allow-clear>
                  <a-select-option value="guzhu">雇主端</a-select-option>
                  <a-select-option value="shifu">师傅端</a-select-option>
                  <a-select-option value="share">分享端</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="状态">
                  <a-select placeholder="请选择" v-model="queryParam.status" style="width: 100%" allow-clear>
                    <a-select-option v-for="d in statusOptions" :key="d.value" :value="d.value">{{ d.label }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {}">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleAdd" v-hasPermi="['system:banner:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['system:banner:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting :style="{ float: 'right' }" :table-size.sync="tableSize" v-model="columns"
          :refresh-loading="loading" @refresh="getList" />
      </div>
      <!-- 数据展示 -->
      <a-table :loading="loading" :size="tableSize" rowKey="id" :columns="columns" :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :pagination="false"
        :bordered="tableBordered">
        <span slot="imageUrl" slot-scope="text, record">
          <img v-if="record.imageUrl" :src="record.imageUrl" style="width: 80px; height: 60px; object-fit: cover; border-radius: 4px;" />
          <span v-else>-</span>
        </span>
        <span slot="clientType" slot-scope="text, record">
          <a-tag v-if="record.clientType === 'guzhu'" color="blue">雇主端</a-tag>
          <a-tag v-else-if="record.clientType === 'shifu'" color="green">师傅端</a-tag>
          <a-tag v-else-if="record.clientType === 'share'" color="orange">分享端</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-switch :checked="record.status === 1" @change="handleStatusChange(record)" />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleUpdate(record)" v-hasPermi="['system:banner:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['system:banner:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['system:banner:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="queryParam.pageNum"
        :total="total" :page-size="queryParam.pageSize" :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange" @change="changeSize" />
    </a-card>

    <!-- 新增/编辑弹窗 -->
    <a-modal
      :title="formTitle"
      :visible="open"
      :confirm-loading="confirmLoading"
      @ok="submitForm"
      @cancel="cancel"
      :destroyOnClose="true"
    >
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="标题" prop="title">
          <a-input v-model="form.title" placeholder="请输入标题" allow-clear />
        </a-form-model-item>
        <a-form-model-item label="客户端" prop="clientType">
          <a-select placeholder="请选择客户端" v-model="form.clientType" style="width: 100%">
            <a-select-option value="guzhu">雇主端</a-select-option>
            <a-select-option value="shifu">师傅端</a-select-option>
            <a-select-option value="share">分享端</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="轮播图片" prop="imageUrl">
          <file-upload
            :value="form.imageUrl"
            type="image"
            :count="1"
            :maxSize="5"
            accept=".jpg,.jpeg,.png,.gif,.webp"
            @input="handleImageUpload"
          />
          <div v-if="form.imageUrl" style="margin-top: 8px;">
            <img :src="form.imageUrl" style="max-width: 200px; max-height: 150px; border-radius: 4px;" />
          </div>
        </a-form-model-item>
        <a-form-model-item label="排序" prop="sort">
          <a-input-number v-model="form.sort" :min="0" style="width: 100%" placeholder="数字越小越靠前" />
        </a-form-model-item>
        <a-form-model-item label="状态" prop="status">
          <a-radio-group v-model="form.status">
            <a-radio :value="1">启用</a-radio>
            <a-radio :value="0">停用</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remark">
          <a-textarea v-model="form.remark" placeholder="请输入备注" :rows="3" allow-clear />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { pageBanner, getBanner, addBanner, updateBanner, delBanner } from '@/api/system/banner'
import { tableMixin } from '@/store/table-mixin'
import FileUpload from '@/components/FileUpload/index.vue'

export default {
  name: 'Banner',
  components: {
    FileUpload
  },
  mixins: [tableMixin],
  data() {
    return {
      statusOptions: [
        { label: '启用', value: '1' },
        { label: '停用', value: '0' }
      ],
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        title: undefined,
        clientType: undefined,
        status: undefined
      },
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          width: '6%',
          align: 'center'
        },
        {
          title: '预览图',
          dataIndex: 'imageUrl',
          scopedSlots: { customRender: 'imageUrl' },
          width: '12%',
          align: 'center'
        },
        {
          title: '标题',
          dataIndex: 'title',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '客户端',
          dataIndex: 'clientType',
          scopedSlots: { customRender: 'clientType' },
          width: '10%',
          align: 'center'
        },
        {
          title: '排序',
          dataIndex: 'sort',
          width: '8%',
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          width: '8%',
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: '15%',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '12%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      // 弹窗
      open: false,
      formTitle: '',
      confirmLoading: false,
      form: {
        id: undefined,
        title: '',
        imageUrl: '',
        clientType: 'guzhu',
        sort: 0,
        status: 1,
        remark: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        imageUrl: [
          { required: true, message: '请上传轮播图片', trigger: 'change' }
        ],
        clientType: [
          { required: true, message: '请选择客户端', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    /** 查询轮播图列表 */
    getList() {
      this.loading = true
      pageBanner(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        title: undefined,
        clientType: undefined,
        status: undefined
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 切换状态 */
    handleStatusChange(record) {
      const newStatus = record.status === 1 ? 0 : 1
      const that = this
      this.$confirm({
        title: '提示',
        content: `确认${newStatus === 1 ? '启用' : '停用'}该轮播图？`,
        onOk() {
          return updateBanner({
            id: record.id,
            status: newStatus
          }).then(() => {
            record.status = newStatus
            that.$message.success('操作成功')
          })
        },
        onCancel() {}
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const bannerIds = row.id || this.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + bannerIds + '的数据',
        onOk() {
          return delBanner(bannerIds)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success('删除成功', 3)
            })
        },
        onCancel() {}
      })
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.resetForm()
      this.formTitle = '添加轮播图'
      this.open = true
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.resetForm()
      this.formTitle = '编辑轮播图'
      getBanner(row.id).then(response => {
        const data = response.data
        this.form = {
          id: data.id,
          title: data.title,
          imageUrl: data.imageUrl,
          clientType: data.clientType,
          sort: data.sort,
          status: data.status,
          remark: data.remark
        }
        this.open = true
      })
    },
    /** 图片上传回调 */
    handleImageUpload(fileList) {
      if (fileList && fileList.length > 0) {
        // FileUpload 组件单图模式下返回 fileList 数组
        this.form.imageUrl = fileList[0].url || fileList[0].path
      } else {
        this.form.imageUrl = ''
      }
    },
    /** 提交表单 */
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.confirmLoading = true
        const api = this.form.id ? updateBanner(this.form) : addBanner(this.form)
        api.then(() => {
          this.$message.success(this.form.id ? '修改成功' : '新增成功')
          this.open = false
          this.getList()
        }).finally(() => {
          this.confirmLoading = false
        })
      })
    },
    /** 取消按钮 */
    cancel() {
      this.open = false
      this.resetForm()
    },
    /** 重置表单 */
    resetForm() {
      this.form = {
        id: undefined,
        title: '',
        imageUrl: '',
        clientType: 'guzhu',
        sort: 0,
        status: 1,
        remark: ''
      }
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    }
  }
}
</script>
